/** Query keys for a Société account's change log. */
export const accountChangeLogQueryKeys = {
  all: ['lux-loyalty-account-change-log'] as const,
  byCustomer: (customerId: string) => [...accountChangeLogQueryKeys.all, customerId] as const,
  page: (customerId: string, pagination: { page: number; pageSize: number }) =>
    [...accountChangeLogQueryKeys.byCustomer(customerId), pagination] as const,
};
